function hexToRgb(hex: string) {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return [r, g, b]
}

function getColorAtPercentage(start: number[], end: number[], percentage: number) {
  const r = Math.round(start[0] + (end[0] - start[0]) * percentage)
  const g = Math.round(start[1] + (end[1] - start[1]) * percentage)
  const b = Math.round(start[2] + (end[2] - start[2]) * percentage)
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`
}

const getBlockGradient = (startColor: string, endColor: string, num: number) => {
  const [startR, startG, startB] = hexToRgb(startColor)
  const [endR, endG, endB] = hexToRgb(endColor)
  const blockColors = []
  const percentage = Math.floor(100 / num) / 100
  for (let i = 0; i < num; i++) {
    const startPercentage = i * percentage
    const endPercentage = (i + 1) * percentage
    const startBlockColor = getColorAtPercentage([startR, startG, startB], [endR, endG, endB], startPercentage)
    const endBlockColor = getColorAtPercentage([startR, startG, startB], [endR, endG, endB], endPercentage)
    blockColors.push([startBlockColor, endBlockColor])
  }
  return blockColors
}

export default getBlockGradient
